import type { ProcessBankIDVerificationCommandResultStatus } from "Api/Api";
import { type ActionType, createAction, createReducer } from "typesafe-actions";

export enum BankIDVerificationStatus {
  None = "None",
  Processing = "Processing",
}

type VerificationState = {
  bankIDVerificationStatus:
    | BankIDVerificationStatus
    | ProcessBankIDVerificationCommandResultStatus;
};

export const setBankIDVerificationStatus = createAction(
  "@verification/SET_BANK_ID_VERIFICATION_STATUS",
)<BankIDVerificationStatus | ProcessBankIDVerificationCommandResultStatus>();

type VerificationAction = ActionType<typeof setBankIDVerificationStatus>;

export const verificationReducer = createReducer<
  VerificationState,
  VerificationAction
>({
  bankIDVerificationStatus: BankIDVerificationStatus.None,
}).handleAction(setBankIDVerificationStatus, (state, action) => {
  return { ...state, bankIDVerificationStatus: action.payload };
});
